module.exports = [
	{
		id: 1,
		visible: false,
		question: 'Is it really free?',
		answer:
			'Yes, free and unlimited. Just log in and have your unique url. No fuss.',
	},
	{
		id: 2,
		visible: false,
		question: 'Why do I need Webbler?',
		answer:
			"Webbler is a web platform that can be used to create personal websites. You don't have to have any coding skills to use this. Select your template now and start adding your bio, social media links, achievements, photos and videos.  Making it easier for your audience to discover all your content.",
	},
	{
		id: 3,
		visible: false,
		question: 'How do I create a free website with a custom domain?',
		answer:
			'You can create a free website with Webbler that comes with a Webbler domain. Getting adds credibility to your brand and helps visitors find you online. So we will add this feature soon. ',
	},
	{
		id: 4,
		visible: false,
		question: 'How do I make my site mobile friendly?',
		answer:
			'Your Webbler website automatically comes with a mobile-optimized version that looks great on smaller screens. ',
	},
	{
		id: 5,
		visible: false,
		question: 'Is my data safe?',
		answer:
			'Webbler does not track any personal data of your visitors. We take privacy and security seriously. We also have SSL encryption across the platform.',
	},
	{
		id: 6,
		visible: false,
		question: 'I love the product. How can I show my appreciation?',
		answer:
			'Tell your friends how much you love your Webbler. Share something about us on your social media accounts!',
	},
	{
		id: 7,
		visible: false,
		question: 'What if I need help?',
		answer:
			'Please send us an email at hey@webbler.me, or use the chat widget on help.webbler.me.',
	},
];
